interface IActionBarProps {
  applyFilter: () => void
  resetFilter: () => void
  cancelFilter: () => void
  canApply: boolean
}

const ActionBar = ({
  applyFilter,
  resetFilter,
  cancelFilter,
  canApply
}: IActionBarProps) => {
  return (
    <div className='flex justify-between px-5 py-3'>
      <div className='flex w-full justify-end'>
        <div className='grid grid-cols-3 gap-2'>
          <button
            className='w-20 justify-self-end py-2 font-semibold uppercase text-gray-700'
            onClick={cancelFilter}
          >
            Cancel
          </button>
          <button
            className='w-24 py-2 font-semibold uppercase text-lighthouseBlue'
            onClick={resetFilter}
          >
            Reset
          </button>
          <button
            className={[
              'w-24',
              'py-2',
              'rounded bg-lighthouseBlue',
              'text-white',
              'font-semibold',
              'uppercase',
              'disabled:opacity-50'
            ].join(' ')}
            disabled={!canApply}
            onClick={applyFilter}
          >
            Apply
          </button>
        </div>
      </div>
    </div>
  )
}

export default ActionBar
